import React from 'react';
import DOMPurify from 'dompurify';

/**
 * HTMLContent - Safely renders HTML content from CKEditor/Rich Text Editor
 * 
 * This component sanitizes and renders HTML content to prevent XSS attacks
 * while preserving formatting from CMS (bold, italic, lists, links, etc.)
 * 
 * Usage:
 *   <HTMLContent content={job.description} className="custom-class" />
 */
const HTMLContent = ({ content, html, className = '' }) => {
  const actualContent = content || html;
  if (!actualContent) return null;

  // Sanitize HTML to prevent XSS attacks
  const sanitizedHTML = DOMPurify.sanitize(actualContent, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li',
      'a', 'blockquote', 'code', 'pre',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'div', 'span', 'img'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'id', 'src', 'alt', 'title', 'width', 'height'],
    ALLOW_DATA_ATTR: false,
  });

  return (
    <div
      className={`prose prose-sm max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
};

export default HTMLContent;
